import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-modernization-readiness-skeleton',
  templateUrl: './modernization-readiness-skeleton.component.html',
  styleUrls: ['./modernization-readiness-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class ModernizationReadinessSkeletonComponent {
  readonly tabs = [1, 2, 3];
  readonly summaryRows = [1, 2, 3];
  readonly stats = [1, 2, 3, 4];
}